// ProjectBoundingBox.tsx
// Refactored to a pure factory without React hooks. It can be safely called
// during render or memoization without violating Rules of Hooks.

import { ProjectBoundary } from "../../types/project";

const ProjectBoundingBoxLayer = (
  id: string,
  name: string,
  boundary: ProjectBoundary | null | undefined,
  showName: boolean = false,
  fill: boolean = false
) => {
  const geojson = boundary
    ? {
        type: "Feature",
        properties: { id },
        geometry: boundary,
      }
    : null;

  // Define styles
  const lineStyle = !fill
    ? {
        id,
        type: "line" as const,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#FFFF00",
          "line-width": 2,
        },
      }
    : null;

  const fillStyle = fill
    ? {
        id,
        type: "fill" as const,
        paint: {
          "fill-color": "#FFFF00",
          "fill-opacity": 0.2,
        },
      }
    : null;

  const textStyle = showName
    ? {
        id: `${id}-text`,
        type: "symbol" as const,
        layout: {
          "text-field": name,
          "text-size": 18,
          "text-offset": [0, 0.5],
          "text-anchor": "top",
        },
        paint: { "text-color": "#FFFF00" },
      }
    : null;

  return {
    id,
    name,
    type: "project",
    source: geojson,
    layerStyle: [
      ...(lineStyle ? [lineStyle] : []),
      ...(textStyle ? [textStyle] : []),
      ...(fillStyle ? [fillStyle] : []),
    ],
    toolbarButton: null,
    active: true,
    stale: true,
    setStale: () => {},
  };
};

export default ProjectBoundingBoxLayer;
